import React, { useContext } from "react";
import FeatureList from "../FeatureList/FeatureList";
import MapBox from "../MapBox/MapBox";
import PrivateNavbar from "../Navbar/PrivateNavbar";
import PublicNavbar from "../Navbar/PublicNavbar";

import { SessionContext } from "../../context/SessionContext";

import { ChartDataProvider } from "../../context/ChartDataContext";
import { SpottersProvider } from "../../context/SpottersContext";

const Home = () => {
  const { currentSession } = useContext(SessionContext);

  return (
    <SpottersProvider>
      <ChartDataProvider>
        {currentSession.isLogged ? <PrivateNavbar /> : <PublicNavbar />}
        <FeatureList />
        <MapBox />
      </ChartDataProvider>
    </SpottersProvider>
  );
};

export default Home;
